import {
  IconBadgeStatus,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import React from 'react';
import ScreeningDetailsTooltip from '../ScreeningDetailsTooltip';
import { SCREENING_METHOD_STATUS } from './constants';
import { SUBMITTED_SCREENING_STATUSES } from '../constants';
import messages from '../messages';
import type { ScreeningMethodBoxProps } from './types';

function ScreeningMethodBox({
  intl,
  method,
  screeningStatus,
  hasPendingScreeningMethods,
}: ScreeningMethodBoxProps) {
  return (
    <Stack sx={{ flex: 1 }}>
      <IconBadgeStatus
        variant={method.status}
        tooltipText={method.tooltipText}
      />
      <Typography
        variant="titleMedium"
        color={
          method.status === SCREENING_METHOD_STATUS.NOT_READY
            ? undefined
            : 'text.disabled'
        }
        marginLeft={0.5}
        marginTop={1}
      >
        {method.name}
      </Typography>
      {method.details ? (
        <ScreeningDetailsTooltip intl={intl} details={method.details} />
      ) : (
        // A phased criminal tile reads Not Started by decision, not because the screening stopped.
        !method.phasedCriminal &&
        !hasPendingScreeningMethods &&
        SUBMITTED_SCREENING_STATUSES.includes(screeningStatus) &&
        method.status === SCREENING_METHOD_STATUS.NOT_STARTED && (
          <ScreeningDetailsTooltip
            intl={intl}
            details={intl.formatMessage(messages.screeningStoppedDefaultDetail)}
          />
        )
      )}
    </Stack>
  );
}

export default ScreeningMethodBox;
